export default __webpack_public_path__ + "bf97f6e1191dac71e4324c659d78d4c7.png";